// Onboarding tutorial videos per wizard step, configurable via Expo env
// vars so producción can swap the URLs without a code release. Set any
// of these to a non-empty value to override the static placeholder.
//
//   EXPO_PUBLIC_ONBOARDING_VIDEO_USE_CASE
//   EXPO_PUBLIC_ONBOARDING_VIDEO_IDENTITY
//   EXPO_PUBLIC_ONBOARDING_VIDEO_VOICE
//   EXPO_PUBLIC_ONBOARDING_VIDEO_KNOWLEDGE
//   EXPO_PUBLIC_ONBOARDING_VIDEO_CALLING_HOURS
//   EXPO_PUBLIC_ONBOARDING_VIDEO_REVIEW
//
// Empty / unset → the wizard shows the "coming soon" placeholder.

const ENV_KEYS: Record<string, string | undefined> = {
  'Use Case': process.env.EXPO_PUBLIC_ONBOARDING_VIDEO_USE_CASE,
  Identity: process.env.EXPO_PUBLIC_ONBOARDING_VIDEO_IDENTITY,
  Voice: process.env.EXPO_PUBLIC_ONBOARDING_VIDEO_VOICE,
  Knowledge: process.env.EXPO_PUBLIC_ONBOARDING_VIDEO_KNOWLEDGE,
  'Calling Hours': process.env.EXPO_PUBLIC_ONBOARDING_VIDEO_CALLING_HOURS,
  'Review & Publish': process.env.EXPO_PUBLIC_ONBOARDING_VIDEO_REVIEW,
};

export function getOnboardingVideoUrl(stepName: string): string | null {
  const url = ENV_KEYS[stepName];
  if (!url || url.trim() === '') return null;
  if (!url.startsWith('https://') && !url.startsWith('http://')) return null;
  return url;
}
